import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";

import { ActionButtonComponent } from "@hermes/aphrodite/action-button";
import { CallToActionComponent } from "@hermes/aphrodite/call-to-action";
import { SelectInputComponent } from "@hermes/aphrodite/fields";
import { MediaPictureComponent } from "@hermes/aphrodite/media-picture";
import { MessageBlockComponent } from "@hermes/aphrodite/message-block";
import { RadioButtonComponent } from "@hermes/aphrodite/radio-button";
import {
    svgFindYourSize,
    SvgIconComponent,
    svgMeasureYourself,
    SvgRegistryService,
} from "@hermes/aphrodite/svg";
import {
    TabItemComponent,
    TabListComponent,
    TabTitleDirective,
} from "@hermes/aphrodite/tab";
import { TrayStateModule, TRAY_COMPONENT } from "@hermes/states/tray";

import { BlockImageComponent } from "./components/block-image/block-image.component";
import { BlockPdfComponent } from "./components/block-pdf/block-pdf.component";
import { BlockStepsComponent } from "./components/block-steps/block-steps.component";
import { BlockTableComponent } from "./components/block-table/block-table.component";
import { CallToActionSizeGuideComponent } from "./components/call-to-action-size-guide/call-to-action-size-guide.component";
import { FindYourSizeComponent } from "./components/find-your-size/find-your-size.component";
import { MeasureYourselfComponent } from "./components/measure-yourself/measure-yourself.component";
import { SizeGuideComponent } from "./components/size-guide/size-guide.component";
import { SizeGuideService } from "./services/size-guide.service";
import { UnitTypeService } from "./services/unit-type.service";

@NgModule({
    imports: [
        CallToActionComponent,
        CommonModule,
        FormsModule,
        MessageBlockComponent,
        RadioButtonComponent,
        ReactiveFormsModule,
        TrayStateModule,
        MediaPictureComponent,
        TabListComponent,
        TabItemComponent,
        TabTitleDirective,
        SelectInputComponent,
        SvgIconComponent,
        ActionButtonComponent,
    ],
    declarations: [
        BlockImageComponent,
        BlockPdfComponent,
        BlockStepsComponent,
        BlockTableComponent,
        CallToActionSizeGuideComponent,
        FindYourSizeComponent,
        MeasureYourselfComponent,
        SizeGuideComponent,
    ],
    providers: [
        {
            provide: TRAY_COMPONENT,
            useValue: SizeGuideComponent,
        },
        UnitTypeService,
        SizeGuideService,
    ],
    exports: [CallToActionSizeGuideComponent],
})
export class SizeGuideTrayStateModule {
    constructor(svgRegistryService: SvgRegistryService) {
        svgRegistryService.registerSvgs([svgFindYourSize, svgMeasureYourself]);
    }
}
